import React, { useEffect, useState } from "react";
import { desEncriptar } from "../encriptacion";
const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const useGetDataUser = () => {
    const [info, setInfo] = useState()

    useEffect(() => {
        try {
            const token = sessionStorage.getItem('dataClient')
            const decript = desEncriptar(token,key)
            setInfo(JSON.parse(decript))
        }
        catch(error) {
            console.log("no esxiste el token",error);
        }
    }, [])
    return info
}
export default useGetDataUser